import React from 'react';
import { createRoot } from 'react-dom/client';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { configureIconSet } from '@toqio/toqio-web-components';

import iconPaths from 'components/icon/selection.json';
import { setLanguage } from 'src/i18n/i18n';
import { ThemedApp } from 'src/CustomerThemedApp';
import { theme } from 'src/ThemeProvider';
import { setWorkflowsInterceptor } from 'utils/network-service'
import workflowsMethods from 'src/utils/workflowsCustomMethods'

import "@flowable/work-views/dist/react-polyfill";
import * as WFsCustomComponents from "extensions/dist/custom_v1.1.56.js";

const root = createRoot(document.getElementById('root')!);

const browserLanguage = navigator.language || (navigator as any).userLanguage;

void setLanguage(browserLanguage);
configureIconSet(iconPaths)
setWorkflowsInterceptor()

// Create a query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
      refetchOnWindowFocus: false,
    }
  }
});

// WORKFLOWS URL CONFIGURATION
window.flowable = window.flowable || {};
// WFs externals
window.flowable.externals = { ...window.flowable.externals, ...WFsCustomComponents };
window.flowable.externals.additionalData = {
  ...window.flowable.externals.additionalData,
  ...workflowsMethods,
  customMethods: {
    ...window.flowable.externals.additionalData?.customMethods,
    ...workflowsMethods?.customMethods
  },
}
// WORKFLOWS ENVIRONMENT CONFIGURATION
const DEFAULT_CLIENT = 'toqio';
const DEFAULT_ENV = 'prod';
const CLIENT = process.env.CUSTOMER_THEME?.toLowerCase() || DEFAULT_CLIENT;
const ENV = process.env.ENVIRONMENT?.toLowerCase() || DEFAULT_ENV;
window.WORKFLOWS_ENVIRONMENT = {
  ENV: ENV === 'local' ? 'dev' : ENV, // if local use dev environment
  CUSTOMER: CLIENT
};

root.render(
  <React.StrictMode>
    <I18nProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <ThemedApp theme={theme} />
      </QueryClientProvider>
    </I18nProvider>
  </React.StrictMode>
);
